module.exports = __webpack_public_path__ + "img/model_31.8a418d06.jpg";